import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { openModal } from '../../actions/ModalActions';
import UserFormModal from '../../components/user/UserFormModal'
import UserAvatar from '../../components/UserAvatar';

@connect(
	state => ({
		currentUser: state.auth.user,
		users: state.users.users,
		isLoaded: state.users.loaded
	}),
	{ push, openModal }
)
export default class ManageUsers extends Component {

	viewUser(user, e){
		e.preventDefault();		
		this.props.push('/admin/user/' + user.id);
	}

    render() {
		var { openModal, users, currentUser } = this.props;
		var salesRoleId = 3;
		var activeUsers = users.filter(user => ! user.deletedAt);
		var showAddUser = currentUser.userRole.name === 'Admin';

        return (
            <div className="row page-todo">
            	<div>                	 	           		 	           	
                     <UserProfileList openModal={openModal} showAddUser={showAddUser} name="Sales team" users={activeUsers.filter(user => user.userRoleId == salesRoleId)} />
                     <UserProfileList openModal={openModal} showAddUser={showAddUser} name="All Staff" users={activeUsers} />
            	</div>
            </div>
        );
    }
}

class UserProfileList extends Component {

	sortAlphabetical(a, b){
		return a.firstName.localeCompare(b.firstName);
	}


	openUserForm(e){
		e.preventDefault();
		this.props.openModal(UserFormModal)
	}

	render(){
		return (
			<div className="panel panel-default">
				<div className="panel-heading">
					<h2><i className="fa fa-user"></i>{this.props.name}</h2>
					{
						this.props.showAddUser &&
						<button type="button" onClick={this.openUserForm.bind(this)} className="btn btn-sm btn-info pull-right" style={{marginTop: '5px'}}><i className="fa fa-plus-square" style={{color : '#fff'}}></i> New Staff</button>
					}
				</div>
				<div className="panel-body no-padding">												
					<ul className="userProfileContainer">
						{ this.props.users.sort(this.sortAlphabetical).map((user) => {
							return (
								<li className="userProfile" key={user.id}>
									<Link to={`/teams/user/${user.id}`}>
										<UserAvatar user={user} size="80" />
									</Link>
									<Link to={`/teams/user/${user.id}`}>
										<h1>{user.firstName + ' ' + user.lastName}</h1>
									</Link>
								</li>
							)
						})}
					</ul>
				</div>                
             </div>			
		)
	}
}


// WEBPACK FOOTER //
// ./app/pages/admin/ManageUsers.js